export const DATE_FORMAT = {
  DD_MM_YYYY: "DD-MM-YYYY",
  MM_DD_YYYY: "MM-DD-YYYY",
};

export const OTHER_OPTION_VALUE = "Other (please specify below):";
export const DUMMY_TEXT = {
  SEC_HEADING_TXT:
    "Please note that is appropriate to select a response even if the diagnosis is not confirmed but is strongly suspected or likely at the time of patient’s discharge.",
  DOC_TYPE_INDICATOR:
    "“Patient is admitted to the hospital for treatment of a non-ST-elevation myocardial infarction (NSTEMI) and heart failure. Her echocardiogram reveals an ejection fraction of 20% with wall motion abnormalities.”",
  THIRD_HEADING_TXT:
    "Please Document your response from the choices provided in this query form, and if possible, also document your response in your notes and/or discharge summary, In case there are any questions or concerns, please contact: [CDI user email]",
  FINAL_DISCLAIMER_TXT: `In responding to this documentation clarification request to
                  accurately capture the patient's disease burden and severity of
                  illness, please exercise your independent professional judgment.
                  The fact that a question is asked does not imply that any
                  particular diagnosis is desired or expected`,
  FIRST_HEADING_TXT: `Based on your medical judgment and listed clinical indicators,
            please clarify if there is a diagnosis that correlates with provided
            patient care, requiring monitoring, evaluation and/or treatment
            during this inpatient visit.`,

  LABEL_ACUITY: "Acuity of Heart Failure",
  LABEL_TYPE: "Type of Heart Failure",
  LABEL_POA: "Present on Admission",
};

export const MESSAGE_STATUS_OPTION = [
  {
    value: "OPEN",
    label: "Open",
  },
  {
    value: "CLOSED",
    label: "Closed",
  },
];

export const allowedSignaturePattern = /^[a-zA-Z _-]*$/;
export const ERROR_500 = "Something went wrong";

export const querySubmittedStates = [2, 4, 5, 6, 7, 8, 9];
export const unauthorizedPageErrorMessage = `FHIR client failed to initialize. This could be due to network issues, authentication problems, or incompatible EHR system.`;
export const unauthorizedPageResolutionMessage = `Please close & re-launch the application from your EHR system to continue.`;
